// Module
var code = "<div class=\"marketing-banner theme-background-color-secondary\" ng-class=\" {\n        'has-banner-url': $ctrl.eventBannerSettings.bannerUrl\n    } \" ng-click=\" $ctrl.goToBannerLink() \" data-testid=\"clientMarketingBanner\"> <p class=\"marketing-banner-text\" translate=\"{{ $ctrl.eventBannerSettings.bannerText }}\"> </p> </div> ";
// Exports
export default code;